import { useOnlineStatus } from "../../hooks/useOnlineStatus";

export const OfflineBanner = () => {
    const isOnline = useOnlineStatus();

    if (isOnline) return null;

    return (
        <div className="sticky top-0 inset-x-0 bg-yellow-400 text-black text-sm px-4 py-2 flex justify-between items-center z-50">
            <span>⚠️ You are currently offline. Some features may be limited.</span>
            {/* <button className="text-xl leading-none hover:text-black">&times;</button> */}
        </div>
    );
};
